
import React from 'react'
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'
import ss3 from '../Assets/img/Schemes/ss3.png'; 

const Yashogatha = () => {

    const distID = localStorage.getItem('distributorId');
    const boostID = localStorage.getItem('companyIdBooster');
    const parisID = localStorage.getItem('companyIdParis');

    const { data, error, isLoaded } = GetRequest(`/Yashogatha/GetYashogathalist`);


    if (error !== null) {
        return <Error data="यशोगाथा " />;
    }
    if (!isLoaded) {
        return <Loading />;
    }
 
  return (
    <>
      <section className="content">
        <div className="container-fluid">
          <div className="row"> 
            <div className="col-md-12">
              <div className="card  card-primary">
                <div className="card-header ">
                  <h3 className="card-title"> 
                  यशोगाथा / Farmer Inspiring & Success Story
                  </h3>
                </div>
                <div className="card-body no-padding">
                <div className="row"> 
                {
                    data.result.map((item, index) => (
                      <div className="col-md-6"> 
                      <div className={`callout ${index % 2 === 0 ? 'callout-warning' : 'callout-success'}`} id={item.id}>
                        <h5   className={`setTtleHead ${index % 2 === 0 ? 'bg-warning' : 'bg-success'}`}> {item.title} </h5> 
                        <img src={`${item.image1 == null ? ss3 : item.image1}`} alt=""  className="d-block w-100"  />
                        <p>
                           {item.description}
                        </p>
                        <p>Author Name - {item.authorName} </p>
                    </div>
                    </div>
                  ))
                } 
                 
                </div> 
                </div>
              </div>
            </div> 

          </div>
        </div>
      </section>
    </>
  )
}

export default Yashogatha